var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", [_c("el-dialog", {
    attrs: {
      visible: _vm.visible,
      disabled: _vm.disabled,
      fullscreen: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      },
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }, _vm._l(_vm.reverseList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "box-item"
    }, [_c("el-descriptions", {
      staticClass: "margin-top",
      attrs: {
        column: 6,
        border: ""
      }
    }, [_c("el-descriptions-item", {
      attrs: {
        label: "时间",
        labelStyle: {
          width: "80px"
        }
      }
    }, [_vm._v(" " + _vm._s(item.created_at) + " ")]), _c("el-descriptions-item", {
      attrs: {
        label: "租金/月 ",
        labelStyle: {
          width: "80px"
        }
      }
    }, [_vm._v(" " + _vm._s(item.rent) + " ")]), _c("el-descriptions-item", {
      attrs: {
        labelStyle: {
          width: "80px"
        },
        contentStyle: {
          width: "400px"
        },
        label: "地址"
      }
    }, [_vm._v(" " + _vm._s((item.city_name || "") + "-" + (item.district_name || "") + "-" + (item.address || "")) + " ")]), _c("el-descriptions-item", {
      attrs: {
        labelStyle: {
          width: "80px"
        }
      }
    }, [_c("template", {
      slot: "label"
    }, [_vm._v(" 类型 ")]), _vm._v(" " + _vm._s(_vm.rentTypeName(item.rent_type)) + " ")], 2), _c("el-descriptions-item", {
      attrs: {
        label: "卧室数量",
        labelStyle: {
          width: "80px"
        }
      }
    }, [_vm._v(" " + _vm._s(item.bedroom) + " ")]), _c("el-descriptions-item", {
      attrs: {
        label: "洗手间数量",
        labelStyle: {
          width: "100px"
        }
      }
    }, [_vm._v(" " + _vm._s(item.bathroom) + " ")])], 1), _c("div", {
      key: index,
      staticClass: "img-list"
    }, _vm._l(item.images, function (src, key) {
      return _c("div", {
        key: key,
        ref: "image_".concat(index),
        refInFor: true,
        staticClass: "img-item",
        on: {
          click: function click($event) {
            return _vm.previewImage(item.images, key);
          }
        }
      }, [_c("img", {
        attrs: {
          src: src,
          alt: ""
        }
      })]);
    }), 0)], 1);
  }), 0), !_vm.disabled ? _c("span", {
    on: {
      click: function click($event) {
        _vm.visible = true;
      }
    }
  }, [_c("i", {
    staticClass: "el-icon-time icon",
    class: {
      error: _vm.isImagesChanged
    },
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  })]) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };